import pathToLogo from "../../assets/logo_tweenly_dark.svg"
import Link from "../common/Link"

const HeroLogo = () => {
    return (
        <Link href="/login">
            <img src={pathToLogo} alt="Tweenly logo" width="80%" />
        </Link>
    )
}

export default HeroLogo
